import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);

  private readonly defaultConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom',
  };

  success(message: string, duration?: number): void {
    this.snackBar.open(message, '閉じる', {
      ...this.defaultConfig,
      duration: duration ?? this.defaultConfig.duration,
      panelClass: ['snackbar-success']
    });
  }

  error(message: string, duration?: number): void {
    this.snackBar.open(message, '閉じる', {
      ...this.defaultConfig,
      duration: duration ?? 5000,
      panelClass: ['snackbar-error']
    });
  }

  info(message: string, duration?: number): void {
    this.snackBar.open(message, '閉じる', {
      ...this.defaultConfig,
      duration: duration ?? this.defaultConfig.duration,
      panelClass: ['snackbar-info']
    });
  }
}
